// use this function to push an event to the data layer,
// use data-gtm-link-event-name on <a> links when it's just an event name
export default function pushEventToDataLayer(eventName, additionalProps = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
        ...additionalProps
    });
}